import { useEffect, useState, type CSSProperties } from "react";
import { Film } from "lucide-react";
import { mediaUrl, type VideoItem } from "./catalog";

export default function Poster({ video, hero = false, eager = false }: { video: VideoItem; hero?: boolean; eager?: boolean }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [video.id, video.updatedAt]);
  const hue = parseInt(video.id.slice(0, 4), 16) % 110 + 80;
  return <div className={`v-poster ${hero ? "hero-poster" : ""}`} style={{ "--poster-hue": hue } as CSSProperties}>
    {video.cover && !broken ? <img key={video.updatedAt} src={mediaUrl(video.id, "cover")} alt="" loading={eager ? "eager" : "lazy"} decoding="async" onError={() => setBroken(true)} /> : <div className="v-poster-empty" aria-hidden="true"><Film size={hero ? 64 : 36} strokeWidth={1} /><span>{video.title.slice(0, 12)}</span><small>YESTV</small></div>}
  </div>;
}
